module.exports = __webpack_public_path__ + "static/media/vector-tech-circle-technology-background_43778-322.668affa4.jpg";